import { useEffect, useState } from "react";
import {
  getPeriodWarmProgress,
  pollPeriodWarmStatus,
  startPeriodWarmPolling,
  stopPeriodWarmPolling,
  subscribePeriodWarmProgress,
  type PeriodWarmProgressState,
} from "@/lib/mail/periodWarmProgress";

/** Poll + état — workspace / sidebar uniquement. */
export function usePeriodWarmProgress(accountId?: number): PeriodWarmProgressState {
  const [state, setState] = useState<PeriodWarmProgressState>(() =>
    getPeriodWarmProgress(accountId)
  );

  useEffect(() => {
    return subscribePeriodWarmProgress(() => setState(getPeriodWarmProgress(accountId)));
  }, [accountId]);

  useEffect(() => {
    if (accountId == null) {
      return;
    }

    void pollPeriodWarmStatus(accountId);
    startPeriodWarmPolling(accountId, pollPeriodWarmStatus);

    return () => stopPeriodWarmPolling(accountId);
  }, [accountId]);

  return state;
}
